import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-logo">
                    <img src="/logo.svg" alt="" />
                    CompressImages.org
                </div>
                <nav className="footer-links">
                    <a href="/tools">Tools</a>
                    <a href="/blog">Blog</a>
                    <a href="/about">About</a>
                    <a href="/contact">Contact</a>
                    <a href="/privacy-policy">Privacy</a>
                    <a href="/terms-of-service">Terms</a>
                    <a href="/sitemap">Sitemap</a>
                </nav>
                <div className="footer-legal">
                    © {new Date().getFullYear()} CompressImages.org · All image processing happens in your browser. No images are ever uploaded to our servers.
                </div>
            </div>
        </footer>
        )
}

export default Footer
